import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {CoreTranslationService} from '../../../../../@core/services/translation.service';
import {AuthenticationService} from '../../../../core/service';
import {ActivatedRoute, Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {
  AcquisitionType,
  BenefitType,
  CompanyTaxDistribution,
  CountyLabel,
  Issue,
  maskCnp,
  maskEmail,
  maskPhoneNumber,
  ORDER_STATUS_LABEL,
  OrderStatus,
  PricingPlan,
  SHIPPING_TYPE_LABEL,
  SUBSCRIPTION_LABEL,
  SupportStatusType,
  GetProviderName, SubscriptionStatus, ShippingType,
} from '../../../../core/helpers/constants';
import {HttpErrorResponse} from '@angular/common/http';
import {Subject} from 'rxjs';
import {BenefitDetailsService} from '../../../../core/service/benefit-details.service';
import {AddSupportMessageRequest} from '../../../../core/requests/AddSupportMessageRequest';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {OrdersService} from '../../../../core/service/orders.service';
import {ToastrService} from 'ngx-toastr';
import {SubscriptionPaymentModel} from 'app/core/models/subscription-payments';
import {GetSubcriptionPaymentsResponse} from 'app/core/responses/GetSubscriptionPaymentsResponse';
import {TaxAndFeesTooltipService} from 'app/core/service/tax-and-fees-tooltip.service';
import Swal from 'sweetalert2';
import {TaxService} from "../../../../core/service/tax.service";
import {ClipboardService} from "ngx-clipboard";
import {BenefitSummaryService} from 'app/core/service/benefit-summary.service';
import {BenefitDocument} from 'app/core/models/benefit-document';
import {GetDocumentsRequest} from 'app/core/requests/GetDocumentsRequest';
import {GetBenefitDocumentsResponse} from 'app/core/responses/GetBenefitDocumentsResponse';
import {BenefitHistoryType, BudgetAvailabilityType} from "../../../../core/helpers/enums";
import {OrderDetailsService} from "../../../../core/service/order-details.service";
import {GetOrderDetailsResponse} from "../../../../core/responses/GetOrderDetailsResponse";
import {OrderDetails} from "../../../../core/models/order-details";
import {AutoOrderPaymentModel} from "../../../../core/models/auto-order";
import {AutoOrderService} from "../../../../core/service/auto-order.service";
import {AutoOrderPaymentsResponse} from "../../../../core/responses/AutoOrderResponse";
import {PaymentService} from 'app/core/service/payment.service';
import {RetryPaymentRequest} from 'app/core/requests/RetryPaymentRequest';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
  PensionContributionDialogComponent
} from 'app/main/shared/pension-contribution-dialog/pension-contribution-dialog.component';
import {SubscriptionService} from 'app/core/service/subscription.service';
import {UtilsService} from "../../../../core/service/utils.service";
import {SubdomainInfo} from "../../../../core/models/subdomain-info";
import {redirectToPaymentGateway} from "../../../../core/helpers/payment-redirect.helper";
import {PaymentEncData} from "../../../../core/models/payment-enc-data";
import {CompanyBenefitPolicyRequiredFieldTypeEnum} from "../../../../core/models/company-benefit-policy";
import {InsuranceService} from '../../../../core/service/insurance.service';
import {InsuranceOrderDetails} from '../../../../core/models/insurance-order';

@Component({
  selector: 'app-benefit-details',
  templateUrl: './benefit-details.component.html',
  styleUrls: ['./benefit-details.component.scss'],
  providers: [TranslatePipe],
})
export class BenefitDetailsComponent implements OnInit, OnDestroy {
  public companyId: number = null;
  public itemId: number = null;
  public userId: string = null;
  public orderDetails: OrderDetails = null;

  // Masks a phone number for read-only display, keeping only the last 4
  // digits visible.
  public maskPhone(phone: string): string {
    return maskPhoneNumber(phone);
  }

  // Masks a CNP for read-only display, keeping only the last 6 digits
  // visible.
  public maskCnp(cnp: string): string {
    return maskCnp(cnp);
  }

  // Masks an email for read-only display, e.g. "abc***@*il.com".
  public maskEmail(email: string): string {
    return maskEmail(email);
  }
  public issueValues = Issue;
  public issueForm: FormGroup | null = null;
  private ngUnsubscribe = new Subject<void>();
  public subdomain: string;
  public benefitIsSubscription = false;
  public benefitIsTickets = false;
  public benefitIsAutoOrder = false;
  public subscriptionPayments: SubscriptionPaymentModel[];
  public autoOrderPayments: AutoOrderPaymentModel[];
  public paymentsExpanded = false;
  public companyTaxDistribution: CompanyTaxDistribution;
  public donePayments: string;
  public pendingPayments: string;
  public activationDate: string;
  public nextPayment: Date;
  public taxAndFeesTooltipText: string;
  public documents: Array<BenefitDocument> = null;
  public benefitPrice: number;
  public cardDifference: number;
  public pricingPlan: PricingPlan;
  public isDescriptionExpanded = false;
  public showDescriptionToggle = false;
  public currentLanguage: string;
  public historyType: BenefitHistoryType;
  public userMonthlyBudget: number;
  public budgetAvailabilityStartDay: number;
  public budgetAvailabilityEndDay: number;
  private companyInfo: SubdomainInfo;

  public pensionContribution: number = null;
  public insuranceDetails: InsuranceOrderDetails | null = null;

  private SegmentToBenefitHistoryTypeMap: Record<string, BenefitHistoryType> = {
    'order': BenefitHistoryType.Order,
    'subscription': BenefitHistoryType.Subscription,
    'auto-order': BenefitHistoryType.AutoOrder,
    'insurance': BenefitHistoryType.Insurance,
  };

  constructor(
    private fb: FormBuilder,
    private _coreTranslationService: CoreTranslationService,
    private _translateService: TranslateService,
    private authenticationService: AuthenticationService,
    private _route: ActivatedRoute,
    private paymentService: PaymentService,
    private orderService: OrdersService,
    private benefitDetailsService: BenefitDetailsService,
    private _router: Router,
    private benefitSummaryService: BenefitSummaryService,
    private _toastrService: ToastrService,
    private translate: TranslatePipe,
    private taxAndFeesService: TaxAndFeesTooltipService,
    private taxService: TaxService,
    private clipboardService: ClipboardService,
    private orderDetailsService: OrderDetailsService,
    private subscriptionService: SubscriptionService,
    private autoOrderService: AutoOrderService,
    private modalService: NgbModal,
    private utilsService: UtilsService,
    private insuranceService: InsuranceService,
  ) {
    this.subdomain = this._route.snapshot.params['subdomain'];
    this.currentLanguage = _coreTranslationService.getActiveLang();
    this.authenticationService.currentUserCompanyInfo.subscribe((companyInfo) => {
      this.companyInfo = companyInfo;
      // If company's loadDayType is Fixed (0) the budget availability start day is equal to balance load day
      this.budgetAvailabilityStartDay = companyInfo.balanceLoadDay;
      // Ensure this.budgetAvailabilityEndDay is initialized
      this.computeBudgetAvailabilityEndDay(companyInfo);
      // For loadDayType == WorkDay (1) it is necessary to obtain the Nth working day from the backend
      // and also re-calculate this.budgetAvailabilityEndDay
      if (companyInfo.loadDayType === 1) {
        this.utilsService.getNthWorkingDay(companyInfo.balanceLoadDay, new Date()).subscribe({
          next: response => {
            this.budgetAvailabilityStartDay = new Date(response.responseObject).getDate();
            this.computeBudgetAvailabilityEndDay(companyInfo);
          }
        });
      }
    });
  }

  ngOnInit() {
    this.companyId = this.authenticationService.currentUserValue.companyId;
    this.itemId = this._route.snapshot.params.orderId || '';
    const segment = this._route.snapshot.params.historyType?.toLowerCase();
    this.historyType = this.SegmentToBenefitHistoryTypeMap[segment] ?? BenefitHistoryType.None;

    this.userId = this.authenticationService.currentUserValue.userId;
    this.userMonthlyBudget = this.authenticationService.currentUserInfoValue.monthlyBudget;
    this.companyTaxDistribution = this.authenticationService.currentUserInfoValue.companyTaxDistribution;
    this.pricingPlan = this.authenticationService.currentUserCompanyInfoValue.pricingPlan;

    this.showTaxesForCompany = !this.taxService.hideTaxes(this.companyTaxDistribution, this.companyId);
    switch (this.historyType) {
      case BenefitHistoryType.Order:
        this.loadOrderDetails();
        break;
      case BenefitHistoryType.Subscription:
        this.loadSubscriptionDetails();
        break;
      case BenefitHistoryType.AutoOrder:
        this.loadAutoOrderDetails();
        break;
      case BenefitHistoryType.Insurance:
        this.loadInsuranceDetails();
        break;
    }
    this.issueForm = this.fb.group({
      issue: [null, Validators.required],
      message: ['', Validators.required],
    });
    this._translateService.onLangChange.subscribe(() => {
      this.getActivationDate();
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  firstSentence(): string {
    const full = this.orderDetails?.benefitDescription || '';
    const plainText = full.replace(/<[^>]*>/g, '');
    const firstDotIndex = plainText.indexOf('.') + 1;

    if ((plainText.length <= 300 && firstDotIndex <= 0) || firstDotIndex >= plainText.length) {
      this.showDescriptionToggle = false;
      return full;
    }

    if (plainText.length >= 300 && firstDotIndex <= 0) {
      this.showDescriptionToggle = true;
      return full.substring(0, full.indexOf(plainText.slice(300))) + '...';
    }

    const slicedText = plainText.slice(0, firstDotIndex).trim();
    this.showDescriptionToggle = true;

    return slicedText;
  }

  /**
   * Get benefit details
   */
  public loadInsuranceDetails() {
    this.insuranceService
      .getInsuranceOrderDetails(this.userId, this.itemId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (d) => {
          this.insuranceDetails = d;
          // Map insurance response to orderDetails so the page renders correctly
          // Price is intentionally not set (stays 0) — not shown for insurance benefits
          this.orderDetails = {
            benefitId: d.benefitId,
            providerId: d.providerId,
            benefitType: BenefitType.Insurance,
            benefitTaxCategory: null,
            pictureUrl: d.pictureUrl,
            providerName: d.providerName,
            date: new Date(d.createdOn),
            orderStatus: d.orderStatus,
            orderStatusLabel: d.orderStatus != null ? ORDER_STATUS_LABEL[d.orderStatus] : null,
            amountWithVAT: 0,
            taxCompany: 0,
            taxEmployee: 0,
            shippingType: d.shippingType,
            shippingTypeLabel: SHIPPING_TYPE_LABEL[d.shippingType],
            acquisitionType: AcquisitionType.OneTime,
            isPlacedByAdmin: false,
            isDeleted: false,
            isOrderInCurrentMonth: false,
          } as any;

          this.benefitPrice = 0;
          this.cardDifference = 0;
          this.loadDocuments();
        },
        error: (err) => { this.onGetBenefitDetailsFail(err); }
      });
  }

  public loadOrderDetails() {
    this.orderDetailsService
      .getOrderDetails(this.itemId, this.userId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data: GetOrderDetailsResponse) => {
          this.onGetBenefitDetailsSuccess(data);
        },
        error: (err) => {
          this.onGetBenefitDetailsFail(err);
        }
      });
  }

  public loadSubscriptionDetails() {
    this.orderDetailsService
      .getSubscriptionDetails(this.itemId, this.userId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data: GetOrderDetailsResponse) => {
          this.onGetBenefitDetailsSuccess(data);
        },
        error: (err) => {
          this.onGetBenefitDetailsFail(err);
        }
      });
  }

  public loadAutoOrderDetails() {
    this.orderDetailsService
      .getAutoOrderDetails(this.itemId, this.userId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data: GetOrderDetailsResponse) => {
          this.onGetBenefitDetailsSuccess(data);
        },
        error: (err) => {
          this.onGetBenefitDetailsFail(err);
        }
      });
  }

  public onGetBenefitDetailsSuccess(data: GetOrderDetailsResponse) {
    const date = new Date(data.responseObject.date);
    this.orderDetails = {
      ...data.responseObject,
      date: date,
      shippingTypeLabel: SHIPPING_TYPE_LABEL[data.responseObject.shippingType],
      orderStatusLabel: data.responseObject.orderStatus ? ORDER_STATUS_LABEL[data.responseObject.orderStatus] : null,
      subscriptionStatusLabel: data.responseObject.subscriptionStatus != null ? SUBSCRIPTION_LABEL[data.responseObject.subscriptionStatus] : null
    };

    this.parseDynamicAttributes();
    this.orderDetails.providerName = GetProviderName(this.orderDetails.providerName, this.subdomain);

    this.benefitIsAutoOrder = this.isAutoOrderBenefit();
    this.benefitIsSubscription = this.isSubscriptionBenefit();
    this.benefitIsTickets = this.isTicketBenefit();
    this.cardDifference = this.orderDetails?.cardPaymentHistory?.length > 0 ? this.orderDetails?.cardPaymentHistory[0]?.cardDifference : 0.00;
    this.benefitPrice = Math.round((this.getOrderAmountToPay() - this.cardDifference) * 100) / 100;

    if (this.benefitIsSubscription) {
      this.orderDetailsService.getSubscriptionPayments(this.itemId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (data: GetSubcriptionPaymentsResponse) => {
            this.onGetPaymentsSuccess(data);
          },
          error: () => {
          }
        });
    }

    if (this.benefitIsAutoOrder && this.historyType === BenefitHistoryType.AutoOrder) {
      this.autoOrderService.getAutoOrderPayments(this.itemId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (data: AutoOrderPaymentsResponse) => {
            this.autoOrderPayments = data.responseObject;
          },
          error: () => {
          }
        });
    }

    const hasNoTaxes = this.taxService.getTotalOrderTaxAmount(this.orderDetails, this.companyTaxDistribution) === 0;
    const isEventBenefit = this.orderDetails.benefitTaxCategory === 1;
    this.taxAndFeesTooltipText = this.taxAndFeesService.setTaxAndFeesTooltip({
      benefitTaxCategory: this.orderDetails.benefitTaxCategory,
      benefitTypeId: this.orderDetails.benefitType
    }, hasNoTaxes, isEventBenefit);
    this.orderDetails.isOrderInCurrentMonth = this.isInCurrentMonth(date);
    this.loadDocuments();
  }

  public loadDocuments() {
    const params: GetDocumentsRequest = {
      paginationCriteria: {
        start: 0,
        limit: 10,
      },
      benefitId: this.orderDetails.benefitId,
    };
    this.benefitSummaryService
      .getBenefitDocuments(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onGetDocumentsSuccess(data);
        },
        (error) => {
          this.onGetDocumentsFail(error);
        }
      );
  }

  public onGetDocumentsSuccess(data: GetBenefitDocumentsResponse) {
    this.documents = data.responseObject.data;

  }

  public onGetDocumentsFail(error: HttpErrorResponse) {
  }

  private isInCurrentMonth(given) {
    if (!given) {
      return false;
    }
    const today = new Date();
    return given.getMonth() === today.getMonth() && given.getFullYear() === today.getFullYear();
  }

  public onGetBenefitDetailsFail(error: HttpErrorResponse) {
  }

  public onGetPaymentsSuccess(response: GetSubcriptionPaymentsResponse) {
    this.subscriptionPayments = response.responseObject;
    let donePayments = 0;
    let pendingPayments = 0;
    this.subscriptionPayments.forEach((payment: SubscriptionPaymentModel) => {
      if (payment.isPayed) {
        donePayments += payment.paymentTotal;
      } else {
        pendingPayments += payment.paymentTotal;
      }
    });
    this.donePayments = donePayments.toFixed(2);
    this.pendingPayments = pendingPayments.toFixed(2);
    this.getActivationDate();
    this.getNextPaymentDate();
  }

  /**
   * Cancel order request
   */
  public cancelOrderRequest() {
    this.orderService
      .cancelOrderRequest(this.itemId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onCancelOrderRequestSuccess();
        },
        (error) => {
          this.onCancelOrderRequestFail(error);
        }
      );
  }

  public onCancelOrderRequestSuccess() {
    this._toastrService.success(
      this.translate.transform('DETAILS.MESSAGES.CANCEL_SUCCESS'),
      this.translate.transform('SUCCESS'),
      {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
    );
    this.orderDetails.orderStatusLabel =
      ORDER_STATUS_LABEL[OrderStatus.Cancelled];
    this.orderDetails.orderStatus = OrderStatus.Cancelled;
    this.authenticationService.updateCurrentUserInfo();
    this.authenticationService.isDirty = true;
  }

  public onCancelOrderRequestFail(error: HttpErrorResponse) {
    this._toastrService.error(
      this.translate.transform('DETAILS.MESSAGES.CANCEL_FAIL'),
      this.translate.transform('ERROR') + '!',
      {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
    );
  }

  /**
   * Send message to support
   */
  public addSupportMessage() {
    const issueVal = this.issueForm.get('issue')?.value;
    const meessageVal = this.issueForm.get('message')?.value;

    if (!issueVal && !meessageVal) {
      this._toastrService.error(
        this.translate.transform('DETAILS.MESSAGES.NO_ISSUE_MESSAGE_FAIL'),
        this.translate.transform('ERROR') + '!',
        {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
      );
      return;
    }
    if (!issueVal) {
      this._toastrService.error(
        this.translate.transform('DETAILS.MESSAGES.NO_ISSUE_FAIL'),
        this.translate.transform('ERROR') + '!',
        {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
      );
      return;
    }
    if (!meessageVal) {
      this._toastrService.error(
        this.translate.transform('DETAILS.MESSAGES.NO_MESSAGE_FAIL'),
        this.translate.transform('ERROR') + '!',
        {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
      );
      return;
    }

    const params: AddSupportMessageRequest = {
      orderId: this.itemId,
      historyType: this.historyType,
      supportStatus: SupportStatusType.New,
      userId: this.userId,
      issue: this.issueForm.get('issue')?.value,
      message: this.issueForm.get('message')?.value,
      userName: `${this.authenticationService.currentUserInfoValue.firstName} ${this.authenticationService.currentUserInfoValue.lastName}`,
      userEmail: `${this.authenticationService.currentUserInfoValue.email}`
    };
    this.benefitDetailsService.addSupportMessage(params).subscribe(
      (_) => {
        this.onAddSupportMessageSuccess();
      },
      (error) => {
        this.onAddSupportMessageFail(error);
      }
    );
  }

  public onAddSupportMessageSuccess() {
    this.issueForm = this.fb.group({
      issue: ['', Validators.required],
      message: ['', Validators.required],
    });
    this._toastrService.success(
      this.translate.transform('DETAILS.MESSAGES.ISSUE_SUCCESS'),
      this.translate.transform('SUCCESS'),
      {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
    );
  }

  public onAddSupportMessageFail(error: HttpErrorResponse) {
    this._toastrService.error(
      this.translate.transform(error.message),
      this.translate.transform('ERROR') + '!',
      {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
    );
  }

  /**
   * Helpers
   */
  public directRetryPayment() {
    const params: RetryPaymentRequest = {
      orderId: this.itemId
    };

    this.paymentService.retrySimpleOrder(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next : data => {
          this.handleDirectPaymentResponse(data.responseObject);
        },
        error : err => {
          const message = err?.messages && err.messages.length > 0 ? err.messages[0] : "BENEFIT_SUMMARY.ORDER_FAIL";
          this._toastrService.error(
            this.translate.transform(message),
            this.translate.transform('ERROR') + '!',
            {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
          );
        }
      }
    );
  }

  private handleDirectPaymentResponse(responseObject: PaymentEncData) {
    const subdomain = this._route.snapshot.params['subdomain'];
    redirectToPaymentGateway(responseObject, subdomain, this._router);
  }

  private getActivationDate() {
    if (!this.subscriptionPayments) {
      return;
    }
    if (this.subscriptionPayments.length > 0) {
      const firstPayment = this.subscriptionPayments[0];
      const firstPaymentDate = new Date(firstPayment.date);
      const language = this._coreTranslationService.getActiveLang();
      this.activationDate = firstPaymentDate.toLocaleString(language, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
    }
  }

  private computeBudgetAvailabilityEndDay(companyInfo: SubdomainInfo) {
    this.budgetAvailabilityEndDay = companyInfo.budgetAvailabilityType === BudgetAvailabilityType.Fixed ?
      companyInfo.budgetAvailabilityInDays :
      this.budgetAvailabilityStartDay + companyInfo.budgetAvailabilityInDays - 1;
  }

  private getNextPaymentDate() {
    if (!this.subscriptionPayments || this.subscriptionPayments.length === 0) {
      return;
    }
    const firstUnpaid = this.subscriptionPayments.find((payment => !payment.isPayed));
    if (firstUnpaid) {
      this.nextPayment = new Date(firstUnpaid.date);
    }
  }

  public isTicketBenefit(): boolean {
    const ticketBenefitTypes = [BenefitType.MealTicket, BenefitType.GiftTicket, BenefitType.CultureTicket, BenefitType.VacationTicket];
    if (!this.orderDetails) {
      return false;
    }

    return ticketBenefitTypes.findIndex(x => x === this.orderDetails.benefitType) > -1;
  }

  public isSubscriptionBenefit() {
    if (!this.orderDetails) {
      return false;
    }

    return this.orderDetails.acquisitionType === AcquisitionType.Subscription;
  }

  public togglePayments() {
    this.paymentsExpanded = !this.paymentsExpanded;
  }

  public isAutoOrderBenefit() {
    if (!this.orderDetails) {
      return false;
    }

    return this.orderDetails.acquisitionType === AcquisitionType.AutoOrder;
  }

  private parseDynamicAttributes() {
    if (this.orderDetails.dynamicAttributes && this.orderDetails.dynamicAttributes.length > 0) {

      const pensionOld = this.orderDetails.dynamicAttributes.find(
        attr => attr.propertyName === 'PensieContributiePersonala' && attr.propertyDisplay
      );

      const pensionNew = this.orderDetails.dynamicAttributes.find(
        attr => attr.propertyName === 'PensieContributiePersonalaNoua' && attr.propertyDisplay
      );

      if (pensionOld?.propertyValue) {
        this.pensionContribution = Number(pensionOld.propertyValue);
      }

      if (pensionNew?.propertyValue && pensionNew.propertyValue !== 'NULL') {
        this.pensionContribution = Number(pensionNew.propertyValue);
      }
    }
  }

  private updatePensionContribution(newValue: number, action: string): void {
    const oldPensionContribution = this.pensionContribution;
    this.pensionContribution = newValue;

    const pensionAttrNew = this.orderDetails.dynamicAttributes.find(
      attr => attr.propertyName === 'PensieContributiePersonalaNoua'
    );
    const pensionAttr = this.orderDetails.dynamicAttributes.find(
      attr => attr.propertyName === 'PensieContributiePersonala'
    );
    if (pensionAttr) {
      pensionAttr.propertyValue = newValue.toString();
    } else if (pensionAttrNew) {
      pensionAttrNew.propertyValue = newValue.toString();
    }

    if (this.historyType === BenefitHistoryType.Subscription && pensionAttr) {
      this.subscriptionService.updateSubscriptionDynamicAttribute(
        this.itemId,
        this.userId,
        {
          propertyName: 'PensieContributiePersonalaNoua',
          propertyValue: newValue.toString()
        }
      ).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: () => {
          const messageKey = action === 'delete'
            ? 'DETAILS.MESSAGES.PENSION_DELETE_SUCCESS'
            : 'DETAILS.MESSAGES.PENSION_UPDATE_SUCCESS';

          this._toastrService.success(
            this.translate.transform(messageKey),
            this.translate.transform('SUCCESS'),
            {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
          );
        },
        error: (error) => {
          // Rollback to previous value in case of error
          this.pensionContribution = oldPensionContribution;

          this._toastrService.error(
            this.translate.transform('DETAILS.MESSAGES.PENSION_UPDATE_ERROR'),
            this.translate.transform('ERROR'),
            {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
          );
        }
      });
    }
  }

  openPensionDialog(): void {
    const modalRef = this.modalService.open(PensionContributionDialogComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.currentValue = this.pensionContribution;

    modalRef.result.then(
      (result) => {
        if (result && result.action) {
          this.updatePensionContribution(result.value, result.action);
        }
      },
      (reason) => {
      }
    );
  }

  isPensionDialogDisabled(): boolean {
    let isStatusNotNew: boolean = this.isSubscriptionBenefit() ?
      this.orderDetails.subscriptionStatus !== SubscriptionStatus.Created :
      this.orderDetails.orderStatus !== OrderStatus.Created;

    const currMonthDay = new Date().getDate();
    const outsideActivationPeriod: boolean =
      !(this.budgetAvailabilityStartDay <= currMonthDay && currMonthDay <= this.budgetAvailabilityEndDay);

    return isStatusNotNew || outsideActivationPeriod;
  }

  get isCancelRestrictedByOrderPeriod(): boolean {
    const restrictedTicketTypes = [BenefitType.MealTicket, BenefitType.VacationTicket, BenefitType.CultureTicket];
    if (!this.orderDetails || restrictedTicketTypes.indexOf(this.orderDetails.benefitType) === -1) {
      return false;
    }
    // Pluxee tickets have their own placement window (meal / tourism / cultural availability days), which can be
    // shorter than the general budget availability window. The cancel restriction must mirror the backend, which
    // gates ticket orders on the per-ticket availability — not on budgetAvailabilityEndDay (general budget).
    if (!this.companyInfo) {
      return false;
    }
    const currMonthDay = new Date().getDate();
    const orderPlacementEndDay = this.computeTicketOrderPlacementEndDay(this.companyInfo, this.orderDetails.benefitType);
    const outsideOrderPlacementPeriod =
      !(this.budgetAvailabilityStartDay <= currMonthDay && currMonthDay <= orderPlacementEndDay);
    return outsideOrderPlacementPeriod;
  }

  private getTicketAvailabilityInDays(companyInfo: SubdomainInfo, benefitType: BenefitType): number {
    switch (benefitType) {
      case BenefitType.MealTicket:
        return companyInfo.mealTicketsAvailabilityInDays;
      case BenefitType.VacationTicket:
        return companyInfo.tourismTicketsAvailabilityInDays;
      case BenefitType.CultureTicket:
        return companyInfo.culturalTicketsAvailabilityInDays;
      default:
        return companyInfo.budgetAvailabilityInDays;
    }
  }

  // Mirrors computeBudgetAvailabilityEndDay but uses the per-ticket availability days for the given ticket type.
  private computeTicketOrderPlacementEndDay(companyInfo: SubdomainInfo, benefitType: BenefitType): number {
    const availabilityInDays = this.getTicketAvailabilityInDays(companyInfo, benefitType);
    return companyInfo.budgetAvailabilityType === BudgetAvailabilityType.Fixed ?
      availabilityInDays :
      this.budgetAvailabilityStartDay + availabilityInDays - 1;
  }

  CancelOrderWithConfirmation() {
    Swal.fire({
      animation: false,
      text: this._translateService.instant('CONFIRM.ORDER_CANCEL.TEXT'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this._translateService.instant('BUTTONS.YES'),
      cancelButtonText: this._translateService.instant('BUTTONS.NO'),
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-secondary ml-1'
      }
    }).then(result => {
      if (result.isConfirmed === true) {
        this.cancelOrderRequest();
      }
    });
  }

  readonly PricingPlan = PricingPlan;
  public showTaxesForCompany: boolean;

  get taxesAndCamAmount(): number {
    const companyTax = this.orderDetails?.taxCompany ?? 0;
    const employeeTax = this.companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE || this.companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE_SALARY
      ? (this.orderDetails?.taxEmployee ?? 0)
      : 0;
    return companyTax + employeeTax;
  }

  get totalOrderAmountWithTaxes(): number {
    return this.taxService.getTotalOrderAmountForDisplay(this.orderDetails, this.companyTaxDistribution);
  }

  getOrderAmountToPay(): number {
    return this.taxService.getAmountToPayFromOrderDetails(this.orderDetails, this.companyTaxDistribution);
  }

  getValidDate(value: string) {
    return new Date(value);
  }

  copyCode(text: string) {
    this.clipboardService.copy(text);
    this._toastrService.info(this.translate.transform("DETAILS.BENEFIT.VOUCHER.COPY_SUCCESS"))
  }

  isInsuranceBenefit(): boolean {
    return this.orderDetails?.benefitType === BenefitType.Insurance;
  }


  protected readonly BenefitHistoryType = BenefitHistoryType;
  protected readonly CompanyTaxDistribution = CompanyTaxDistribution;
  protected readonly OrderStatus = OrderStatus;
  protected readonly CountyLabel = CountyLabel;
  protected readonly RequiredFieldTypes = CompanyBenefitPolicyRequiredFieldTypeEnum;

  protected disableFinalizeButton() {
    if (!this.cardDifference || this.cardDifference == 0) {
      return false;
    }
    if (this.cardDifference == this.orderDetails.amountWithVAT) {
      return false;
    }

    const payFromBudget = this.orderDetails.amountWithVAT - this.cardDifference;
    const user = this.authenticationService.currentUserInfoValue;
    const totalBudget = user.totalAmount + (user.totalAmountTransport ?? 0) + (user.totalAmountProfessionalDevelopment ?? 0) + (user.totalAmountCashback ?? 0);

    return payFromBudget > totalBudget;

  }
}
